module.exports = __webpack_public_path__ + "img/19.d8959eaa.png";